export const initialState = {
    credentials: [],
    loading: false,
    notify: null,
    authToken: localStorage.getItem('authToken')
}

export const Actions = {
    SetAuthToken: 'AUTH_TOKEN',
    UpdateCredentials: "UPDATE_CREDS",
    ClearCredentials: "CLEAR_CREDS",
    ShowLoading: 'SHOW_LOADING',
    HideLoading: 'HIDE_LOADING',
    Notify: 'NOTIFICATION',
}

export const reducer = (state, action) => {
    console.log('reducer', state, action)
    switch (action.type) {
        case Actions.SetAuthToken:
            return {...state, authToken: action.payload.authToken}
        case Actions.UpdateCredentials:
            return { ...state, credentials: [...action.payload] }
        case Actions.ClearCredentials:
            return { ...state, credentials: [] }
        case Actions.ShowLoading:
            return { ...state, loading: true }
        case Actions.HideLoading:
            return { ...state, loading: false }
        case Actions.Notify:
            return { ...state, notify: action.payload }
        default:
            return state
    }
}